
define('text!v3/Common/Components/AbilityGrowthArrows/AbilityGrowthArrows.Component.html',[],function () { return '<div class="ability-growth-arrows" data-bind="css: growthClassCss()">\r\n\t<svg class="icon" data-bind="svgIcon: growthClass(), css: growthClassCss()"></svg>\r\n\t<h5 data-bind="text: growthClassDescription(), css: growthClassCss()"></h5>\r\n</div>\r\n';});

